import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
const categories = [{
  title: "Comprehensive Condo Inspections",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/condo_interior_inspection.png",
  link: "/CondoInspectionPage"
}, {
  title: "Structural & System Analysis",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/electrical_panel_check.png",
  link: "/HomeInspectionServicePage"
}, {
  title: "Safety & Compliance Reports",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/inspection_report_tablet.png",
  link: "/FourPointInspectionSouthFloridaPage"
}];
export default function TechnicalSpecifications() {
  return <section data-section-id="244089" id="overview" className="bg-background text-foreground py-12 md:py-16">
      <div className="container mx-auto px-4">
        {}
        <div className="h-1 w-full bg-primary/10 mb-8 rounded-full"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((category, i) => <Link to={category.link} key={i} data-index={i} className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg">
              <Card className="overflow-hidden h-full transition-all duration-300 hover:shadow-lg border-border bg-card rounded-lg">
                <div className="aspect-[1.8/1] overflow-hidden bg-muted">
                  <img src={category.image} data-wvc-srcset={`${category.image}-wvc-srcset`} data-wvc-sizes={`${category.image}-wvc-sizes`} alt={category.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                </div>
                <CardContent className="p-5">
                  <h3 className="text-xl font-semibold text-secondary font-default group-hover:text-primary transition-colors">
                    {category.title}
                  </h3>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}